/* eslint-disable react/jsx-closing-tag-location, no-nested-ternary, object-property-newline, react/jsx-one-expression-per-line, operator-linebreak, indent */
/** Farm sozlamalari (web): kategoriyalar, amaliyot turlari, materiallar,
 * birliklar, a'zolar. Faqat ferma egasi uchun — backend boshqa rollarga
 * 403 qaytaradi. */
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Layout from '../../components/Layout'
import Loader from '../../components/common/Loader'
import FarmModal from './FarmModal'
import { farmRequest, useFarmList } from './api'

const TABS = ['Kategoriyalar', 'Amaliyot turlari', 'Materiallar', 'Birliklar', 'A’zolar']

export default function FarmSettings() {
    const [tab, setTab] = useState(0)
    return (
        <Layout>
            <nav className="breadcrumb mb-3" aria-label="breadcrumbs">
                <ul>
                    <li><Link to="/farm">Dala boshqaruvi</Link></li>
                    <li className="is-active"><a href="#!">Sozlamalar</a></li>
                </ul>
            </nav>
            <h1 className="title is-4">Farm sozlamalari</h1>

            <div className="tabs is-boxed mb-0">
                <ul>
                    {TABS.map((t, i) => (
                        <li key={t} className={i === tab ? 'is-active' : ''}>
                            <a href="#!" onClick={(e) => { e.preventDefault(); setTab(i) }}>{t}</a>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="box" style={{ borderTopLeftRadius: 0 }}>
                {tab === 0 && (
                    <CrudList url="categories/" columns={[['name', 'Nomi'], ['color', 'Rang']]}
                        renderCell={(item, key) => (key === 'color' && item.color
                            ? <span className="tag" style={{ backgroundColor: item.color, color: '#fff' }}>{item.color}</span>
                            : item[key] || '—')}
                        fields={[
                            { key: 'name', label: 'Nomi *' },
                            { key: 'color', label: 'Rang (hex, masalan #10B981)' },
                        ]} what="Kategoriya" canEdit />
                )}
                {tab === 1 && (
                    <CrudList url="operation-types/" columns={[['name', 'Nomi'], ['isDefault', 'Holat']]}
                        renderCell={(item, key) => (key === 'isDefault'
                            ? (item.isDefault ? <span className="tag is-light">standart</span> : '')
                            : item[key])}
                        fields={[{ key: 'name', label: 'Nomi *' }]}
                        what="Amaliyot turi"
                        canDelete={(item) => !item.isDefault} />
                )}
                {tab === 2 && (
                    <MaterialsCrud />
                )}
                {tab === 3 && (
                    <CrudList url="units/" columns={[['name', 'Nomi'], ['kgFactor', 'kg ekvivalenti']]}
                        renderCell={(item, key) => (key === 'kgFactor'
                            ? (item.kgFactor ? `1 ${item.name} = ${item.kgFactor} kg` : '—')
                            : item[key])}
                        fields={[
                            { key: 'name', label: 'Nomi *' },
                            { key: 'kgFactor', label: 'kg ekvivalenti (ixtiyoriy)', type: 'number' },
                        ]} what="Birlik"
                        canDelete={(item) => !item.isDefault} />
                )}
                {tab === 4 && <MembersCrud />}
            </div>
        </Layout>
    )
}

/** Umumiy sodda CRUD jadval: ro'yxat + qo'shish/tahrirlash modal + o'chirish. */
function CrudList({ url, columns, fields, what, renderCell, canEdit = false, canDelete = () => true }) {
    const [version, setVersion] = useState(0)
    const list = useFarmList(url, {}, [version])
    const [editing, setEditing] = useState(null) // null | {} | item

    async function remove(item) {
        // eslint-disable-next-line no-alert
        if (!window.confirm(`${what} o‘chirilsinmi?`)) return
        try {
            await farmRequest({ url: `${url}${item.id}/`, method: 'DELETE' })
            setVersion((v) => v + 1)
        } catch (e) {
            // eslint-disable-next-line no-alert
            window.alert('O‘chirib bo‘lmadi — bog‘liq yozuvlari bo‘lishi mumkin.')
        }
    }

    return (
        <>
            <div className="has-text-right mb-2">
                <button type="button" className="button is-link is-small"
                    onClick={() => setEditing({})}>+ {what}</button>
            </div>
            {list.loading ? <Loader center /> : (
                <table className="table is-fullwidth is-striped">
                    <thead>
                        <tr>
                            {columns.map(([key, label]) => <th key={key}>{label}</th>)}
                            <th style={{ width: 100 }} />
                        </tr>
                    </thead>
                    <tbody>
                        {list.items.map((item) => (
                            <tr key={item.id}>
                                {columns.map(([key]) => (
                                    <td key={key}>{renderCell ? renderCell(item, key) : item[key]}</td>
                                ))}
                                <td className="has-text-right">
                                    {canEdit && (
                                        <button type="button" className="button is-small is-white mr-1"
                                            onClick={() => setEditing(item)}>
                                            <i className="icon ion-md-create" />
                                        </button>
                                    )}
                                    {canDelete(item) && (
                                        <button type="button" className="button is-small is-white"
                                            onClick={() => remove(item)}>
                                            <i className="icon ion-md-trash has-text-danger" />
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                        {list.items.length === 0 && (
                            <tr><td colSpan={columns.length + 1}
                                className="has-text-centered has-text-grey py-4">Yozuvlar yo‘q.</td></tr>
                        )}
                    </tbody>
                </table>
            )}
            {editing !== null && (
                <SimpleFormModal
                    key={editing.id || 'new'}
                    title={editing.id ? `${what}ni tahrirlash` : `Yangi ${what.toLowerCase()}`}
                    url={url} item={editing.id ? editing : null} fields={fields}
                    onClose={() => setEditing(null)}
                    onSaved={() => { setEditing(null); setVersion((v) => v + 1) }} />
            )}
        </>
    )
}

function SimpleFormModal({ title, url, item, fields, onClose, onSaved }) {
    const [form, setForm] = useState(() => {
        const initial = {}
        fields.forEach((f) => { initial[f.key] = item ? (item[f.key] || '') : '' })
        return initial
    })
    const [saving, setSaving] = useState(false)
    const [error, setError] = useState('')

    async function save(e) {
        e.preventDefault()
        setSaving(true)
        setError('')
        try {
            const data = {}
            fields.forEach((f) => { data[f.key] = form[f.key] === '' ? null : form[f.key] })
            if (!data[fields[0].key]) { setError('Majburiy maydonni to‘ldiring.'); setSaving(false); return }
            await farmRequest(item
                ? { url: `${url}${item.id}/`, method: 'PATCH', data }
                : { url, method: 'POST', data })
            onSaved()
        } catch (err) {
            setError('Saqlashda xato.')
        } finally {
            setSaving(false)
        }
    }

    return (
        <FarmModal title={title} isOpen onClose={onClose} width={420}>
            <form onSubmit={save}>
                {fields.map((f) => (
                    <div className="field" key={f.key}>
                        <label className="label">{f.label}</label>
                        <input className="input" type={f.type || 'text'}
                            step={f.type === 'number' ? '0.0001' : undefined}
                            value={form[f.key]}
                            onChange={(e) => setForm({ ...form, [f.key]: e.target.value })} />
                    </div>
                ))}
                {error && <p className="has-text-danger is-size-7 mb-2">{error}</p>}
                <button type="submit" className={`button is-link is-fullwidth ${saving ? 'is-loading' : ''}`}>
                    Saqlash
                </button>
            </form>
        </FarmModal>
    )
}

/** Materiallar — standart birlik select bilan (alohida, chunki FK bor). */
function MaterialsCrud() {
    const [version, setVersion] = useState(0)
    const materials = useFarmList('materials/', {}, [version])
    const units = useFarmList('units/', {}, [])
    const [editing, setEditing] = useState(null)
    const [form, setForm] = useState({ name: '', defaultUnit: '' })
    const [saving, setSaving] = useState(false)

    function openModal(item) {
        setForm(item && item.id
            ? { name: item.name, defaultUnit: item.defaultUnit || '' }
            : { name: '', defaultUnit: '' })
        setEditing(item || {})
    }

    async function save(e) {
        e.preventDefault()
        if (!form.name.trim()) return
        setSaving(true)
        try {
            const data = { name: form.name.trim(), defaultUnit: form.defaultUnit || null }
            await farmRequest(editing.id
                ? { url: `materials/${editing.id}/`, method: 'PATCH', data }
                : { url: 'materials/', method: 'POST', data })
            setEditing(null)
            setVersion((v) => v + 1)
        } finally {
            setSaving(false)
        }
    }

    async function remove(item) {
        // eslint-disable-next-line no-alert
        if (!window.confirm('Material o‘chirilsinmi?')) return
        await farmRequest({ url: `materials/${item.id}/`, method: 'DELETE' })
        setVersion((v) => v + 1)
    }

    return (
        <>
            <div className="has-text-right mb-2">
                <button type="button" className="button is-link is-small"
                    onClick={() => openModal(null)}>+ Material</button>
            </div>
            {materials.loading ? <Loader center /> : (
                <table className="table is-fullwidth is-striped">
                    <thead>
                        <tr><th>Nomi</th><th>Standart birlik</th><th style={{ width: 100 }} /></tr>
                    </thead>
                    <tbody>
                        {materials.items.map((m) => (
                            <tr key={m.id}>
                                <td>{m.name}</td>
                                <td>{m.defaultUnitName || '—'}</td>
                                <td className="has-text-right">
                                    <button type="button" className="button is-small is-white mr-1"
                                        onClick={() => openModal(m)}>
                                        <i className="icon ion-md-create" />
                                    </button>
                                    <button type="button" className="button is-small is-white"
                                        onClick={() => remove(m)}>
                                        <i className="icon ion-md-trash has-text-danger" />
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {materials.items.length === 0 && (
                            <tr><td colSpan={3} className="has-text-centered has-text-grey py-4">
                                Materiallar yo‘q.
                            </td></tr>
                        )}
                    </tbody>
                </table>
            )}
            {editing !== null && (
                <FarmModal title={editing.id ? 'Materialni tahrirlash' : 'Yangi material'}
                    isOpen onClose={() => setEditing(null)} width={420}>
                    <form onSubmit={save}>
                        <div className="field">
                            <label className="label">Nomi *</label>
                            <input className="input" value={form.name}
                                onChange={(e) => setForm({ ...form, name: e.target.value })} />
                        </div>
                        <div className="field">
                            <label className="label">Standart birlik</label>
                            <div className="select is-fullwidth">
                                <select value={form.defaultUnit}
                                    onChange={(e) => setForm({ ...form, defaultUnit: e.target.value })}>
                                    <option value="">—</option>
                                    {units.items.map((u) => (
                                        <option key={u.id} value={u.id}>{u.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <button type="submit"
                            className={`button is-link is-fullwidth ${saving ? 'is-loading' : ''}`}>
                            Saqlash
                        </button>
                    </form>
                </FarmModal>
            )}
        </>
    )
}

/** A'zolar — telefon raqami bilan taklif, rol tanlash, chiqarish. */
function MembersCrud() {
    const [version, setVersion] = useState(0)
    const members = useFarmList('members/', {}, [version])
    const [showInvite, setShowInvite] = useState(false)
    const [form, setForm] = useState({ phone: '+998', role: 'foreman' })
    const [saving, setSaving] = useState(false)
    const [error, setError] = useState('')

    const ROLE_LABEL = { owner: 'Ega', foreman: 'Brigadir', accountant: 'Hisobchi' }

    async function invite(e) {
        e.preventDefault()
        setSaving(true)
        setError('')
        try {
            await farmRequest({ url: 'members/', method: 'POST', data: form })
            setShowInvite(false)
            setForm({ phone: '+998', role: 'foreman' })
            setVersion((v) => v + 1)
        } catch (err) {
            const d = err.response && err.response.data
            setError((d && d.phone && d.phone[0]) || 'Taklif qilishda xato.')
        } finally {
            setSaving(false)
        }
    }

    async function remove(m) {
        // eslint-disable-next-line no-alert
        if (!window.confirm('A’zo chiqarilsinmi?')) return
        await farmRequest({ url: `members/${m.id}/`, method: 'DELETE' })
        setVersion((v) => v + 1)
    }

    if (members.error && members.error.status === 403) {
        return (
            <p className="has-text-grey has-text-centered py-5">
                A’zolarni faqat ferma egasi boshqaradi.
            </p>
        )
    }

    return (
        <>
            <div className="has-text-right mb-2">
                <button type="button" className="button is-link is-small"
                    onClick={() => setShowInvite(true)}>+ A’zo taklif qilish</button>
            </div>
            {members.loading ? <Loader center /> : (
                <table className="table is-fullwidth is-striped">
                    <thead>
                        <tr><th>Ism</th><th>Telefon</th><th>Rol</th><th style={{ width: 60 }} /></tr>
                    </thead>
                    <tbody>
                        {members.items.map((m) => (
                            <tr key={m.id}>
                                <td>{m.userName || '—'}</td>
                                <td>{m.userPhone}</td>
                                <td>{ROLE_LABEL[m.role] || m.role}</td>
                                <td className="has-text-right">
                                    <button type="button" className="button is-small is-white"
                                        onClick={() => remove(m)}>
                                        <i className="icon ion-md-trash has-text-danger" />
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {members.items.length === 0 && (
                            <tr><td colSpan={4} className="has-text-centered has-text-grey py-4">
                                A’zolar yo‘q. Brigadir/hisobchini telefon raqami bilan taklif qiling
                                (ilovada ro‘yxatdan o‘tgan bo‘lishi kerak).
                            </td></tr>
                        )}
                    </tbody>
                </table>
            )}
            {showInvite && (
                <FarmModal title="A’zo taklif qilish" isOpen
                    onClose={() => setShowInvite(false)} width={420}>
                    <form onSubmit={invite}>
                        <div className="field">
                            <label className="label">Telefon raqami</label>
                            <input className="input" value={form.phone}
                                onChange={(e) => setForm({ ...form, phone: e.target.value })} />
                        </div>
                        <div className="field">
                            <label className="label">Rol</label>
                            <div className="select is-fullwidth">
                                <select value={form.role}
                                    onChange={(e) => setForm({ ...form, role: e.target.value })}>
                                    <option value="foreman">Brigadir — yozuv kiritadi, moliya yopiq</option>
                                    <option value="accountant">Hisobchi — moliya ochiq</option>
                                </select>
                            </div>
                        </div>
                        {error && <p className="has-text-danger is-size-7 mb-2">{error}</p>}
                        <button type="submit"
                            className={`button is-link is-fullwidth ${saving ? 'is-loading' : ''}`}>
                            Taklif qilish
                        </button>
                    </form>
                </FarmModal>
            )}
        </>
    )
}
